const DashboardUsertitle = [
    "Employee Id",
    "Name",
    "Email",
    "Reporting Manager",
    "Branch",
  ];
  
  export default DashboardUsertitle;
  